const routers = [
    {
        path: '/home',
        name: 'home',
        meta: {
            exp: '首页',
            requireAuth: false
        },
        component: () => import('@/views/home/index.vue'),
    },
    {
        path: '/home_VR',
        name: 'home_VR',
        meta: {
            exp: 'home_VR',
            requireAuth: false
        },
        component: () => import('@/views/VR/index.vue'),
    },
    {
        path: '/exhibitions_list',
        name: 'exhibitions_list',
        meta: {
            exp: '展览列表',
            requireAuth: false
        },
        component: () => import('@/views/pro/list/exhibitions_list.vue'),
    },
    {
        path: '/work_list',
        name: 'work_list',
        meta: {
            exp: '作品列表',
            requireAuth: false
        },
        component: () => import('@/views/pro/list/work_list.vue'),
    },
    {
        path: '/pro_detail',
        name: 'pro_detail',
        meta: {
            exp: '作品详情',
            requireAuth: false
        },
        component: () => import('@/views/pro/detail/index.vue'),
    },
    {
        path: '/exhibitions_detail',
        name: 'exhibitions_detail',
        meta: {
            exp: '展览详情',
            requireAuth: false
        },
        component: () => import('@/views/pro/detail/exhibitions_detail.vue'),
    },
    {
        path: '/vr_detail',
        name: 'vr_detail',
        meta: {
            exp: 'vr详情',
            requireAuth: false
        },
        component: () => import('@/views/pro/detail/vr_detail.vue'),
    },
    {
        path: '/school_list',
        name: 'school_list',
        meta: {
            exp: '院校列表',
            requireAuth: false
        },
        component: () => import('@/views/school/list/index.vue'),
    },

    {
        path: '/school_index',
        name: 'school_index',
        meta: {
            exp: '院校主页',
            requireAuth: false
        },
        redirect: '/school_exhibition',
        children: [
            {
                path: '/school_exhibition',
                name: 'school_exhibition',
                meta: {
                    exp: '院校展览',
                    requireAuth: false
                },
                component: () => import('@/views/school/exhibition/index.vue'),
            },
            {
                path: '/school_student',
                name: 'school_student',
                meta: {
                    exp: '院校作品',
                    requireAuth: false
                },
                component: () => import('@/views/school/student/index.vue'),
            },
            {
                path: '/school_teacher',
                name: 'school_teacher',
                meta: {
                    exp: '院校设计师',
                    requireAuth: false
                },
                component: () => import('@/views/school/teacher/index.vue'),
            },
            {
                path: '/school_vr',
                name: 'school_vr',
                meta: {
                    exp: 'vr',
                    requireAuth: false
                },
                component: () => import('@/views/school/vr/index.vue'),
            },
        ],
        component: () => import('@/views/school/index/index.vue'),
    },
    {
        path: '/about_us',
        name: 'about_us',
        meta: {
            exp: '关于在展',
            requireAuth: false
        },
        component: () => import('@/views/about/index.vue'),
    },
    {
        path: '/agree',
        name: 'agree',
        meta: {
            exp: '协议',
            requireAuth: false
        },
        component: () => import('@/views/agreement/index.vue'),
        redirect: '/user_agreement',
        children: [
            {
                path: '/user_agreement',
                name: 'user_agreement',
                meta: {
                    exp: '用户协议',
                    requireAuth: false
                },
                component: () => import('@/views/agreement/user_agreement/index.vue'),
            },
            {
                path: '/privacy_statement',
                name: 'privacy_statement',
                meta: {
                    exp: '隐私声明',
                    requireAuth: false
                },
                component: () => import('@/views/agreement/privacy_statement/index.vue'),
            }
        ]
    },
    {
        path: '/copyright_protection',
        name: 'copyright_protection',
        meta: {
            exp: '产权保护',
            requireAuth: false
        },
        component: () => import('@/views/copyright_protection/index.vue'),
    },
]
export default routers
